import { apiClient } from "@/lib/apiClient";
import type { PaginatedApiResponse } from "@/lib/apiClient";

export interface Seller {
  id: string;
  name: string;
  email?: string;
  phone_number?: string;
  total_orders?: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  owner_id?: string;
  domain?: string;
  category?: string;
  niche?: string;
  logo?: string;
  banner?: string;
  about?: string;
  onboarding_completed?: boolean;
  [k: string]: any;
}

export async function listSellers(params?: Record<string, unknown>) {
  // apiClient.getPaginated<T> expects T to be the item type (not an array),
  // so pass `Seller` not `Seller[]` to avoid returning `Seller[][]`.
  return await apiClient.getPaginated<Seller>("/api/v1/admin/:storeId/sellers", params);
}

export async function getSellerById(id: string) {
  return await apiClient.get<Seller>(`/api/v1/admin/:storeId/sellers/${id}`);
}
